/**
 * @generated SignedSource<<35749016dfee9661f0c68a71b3ac5b2c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LatestReleaseFragment$data = {
  readonly latestRelease: {
    readonly assets: ReadonlyArray<{
      readonly description: string;
      readonly id: string;
      readonly location: string | null | undefined;
      readonly name: string;
      readonly size: string;
      readonly softwareVersionId: string;
      readonly type: string;
    }>;
    readonly id: string;
    readonly lastUpdatedDate: any | null | undefined;
    readonly publishedDate: any;
    readonly releaseNumber: string;
    readonly softwareId: string;
  } | null | undefined;
  readonly " $fragmentType": "LatestReleaseFragment";
};
export type LatestReleaseFragment$key = {
  readonly " $data"?: LatestReleaseFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"LatestReleaseFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LatestReleaseFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SoftwareVersion",
      "kind": "LinkedField",
      "name": "latestRelease",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "softwareId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "releaseNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publishedDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastUpdatedDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Asset",
          "kind": "LinkedField",
          "name": "assets",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "size",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "location",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "softwareVersionId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Software",
  "abstractKey": null
};
})();

(node as any).hash = "ca4c8f0037defd4f497cf85d835d91a6";

export default node;
